module.exports = "/_next/static/images/kickoff-logo-standard-white-c2269458011e264821ffee09b3fc9bb9.svg";